export default {
  header: 'Smaak',
};
